var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    enableBackground: "new 0 0 15 15",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 15,
    height: 15,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAMAAAAMCGV4AAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAqFBMVEUAAABDoEdDoEdDoEdD oEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdD oEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdD oEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEdDoEf///+VKCjgAAAANnRSTlMAABRQ hZdRA8P1UnLz9Pui0P2RCTPfxf6WDDzg9/Lemw45120wyKEQNdTNGR8SMREtng0pyaj87DUdAAAA AWJLR0Q3MLi4RwAAAAd0SU1FB+YLHAo1I2wXvRsAAACgSURBVAjXVY/nEoIwEITvkpACUbCBDbEX 7O3e/9EMiTOO9+u+Kzu7AIjIuIiEZK4Dh0pqQ0RGx8oNUCWWQrUS5Tj+YjvNjERgOmCn2+sPcgbc eCyGIxxPphwEUTkjqua4WBIJiKhcrTfbHe4P7ixy+/qIpzNesuZNuP8ivSLe6gYN9/r3x/PlVTUD lJaKd+7Ryj9/1vv7+ZcqBAr5uM/3AWB1FmjTkqyEAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIyLTEx LTI4VDEwOjUzOjM1KzAwOjAw7L7FlwAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMi0xMS0yOFQxMDo1 MzozNSswMDowMJ3jfSsAAAAodEVYdGRhdGU6dGltZXN0YW1wADIwMjItMTEtMjhUMTA6NTM6MzUr MDA6MDDK9lz0AAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeen);
export default __webpack_public_path__ + "static/media/seen.c48b6f142b9b1930f2c73e34c137c10a.svg";
export { ForwardRef as ReactComponent };